// extracted by mini-css-extract-plugin
module.exports = {"customDrawer":"mobilemenu_customDrawer__XNvtI"};